import { useTheme } from '@dhl-ui/theme'

/**
 * Only check if the "mobile" variant is active
 *
 * This does not or never will check if its really on a mobile device, since the consumer can decide on which
 * variant to stay. Or has specific devides for mobile views.
 */
export const useIsMobileVariant = () => {
  const { variant } = useTheme()

  return variant === 'mobile'
}
